<template>
  <div class="attr-searh-wrapper">
    <div class="wrapper">
      <div class="title">
        搜索文化点 <span class="fa fa-close" @click="closePanle()"></span>
      </div>
      <div class="content">
        <div class="filter">
          <el-input
            placeholder="查找地图上内容"
            v-model="searchText"
            size="mini"
          >
            <el-select
              v-model="searchLayer"
              slot="prepend"
              placeholder="请选择图层"
              style="width: 85px"
            >
              <el-option label="点图层" value="Point"></el-option>
              <el-option label="线图层" value="Line"></el-option>
              <el-option label="面图层" value="Polygon"></el-option>
            </el-select>
            <template slot="append">
              <span
                class="fa fa-search"
                title="查询地图上的要素"
                style="cursor: pointer; padding: 0 10px"
                @click="searchFeature()"
              ></span>
            </template>
          </el-input>
        </div>
      </div>
    </div>
    <SearchResult :searchResult="searchResult"></SearchResult>
  </div>
</template>
<script>
import SearchResult from "./SearchResult.vue";
export default {
  name: "AttrSearchManage",
  props: {
    closeAllPanel: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchText: "",
      searchLayer: "Point",
      isMapSearching: false,
      searchResult: [],
    };
  },
  watch: {},
  computed: {},
  components: { SearchResult },
  methods: {
    closePanle() {
      this.$store.commit("setSearchResultFeatureIDs", {
        point_gids: null,
        line_gids: null,
        polygon_gids: null,
      });
      this.closeAllPanel();
      this.$store.commit("setSearchResultDialogType", 0);
    },
    //按照装属性查找要素
    searchFeature() {
      if (this.isMapSearching) {
        this.$message("查询中，请无重复提交！");
        return;
      }
      if (this.searchText == "") {
        this.$message("请输入关键词！");
        return;
      }

      let url = "";
      if (this.searchLayer == "Point") {
        url = "/api/gis_app/culture_point/";
      } else if (this.searchLayer == "Line") {
        url = "/api/gis_app/culture_line/";
      } else {
        url = "/api/gis_app/culture_polygon/";
      }
      this.isMapSearching = true;
      this.$axios({
        url: url,
        method: "get",
        params: { keyword: this.searchText },
      }).then((res) => {
        let { status, data } = res.data;
        if (status === 200) {
          let gids = [];
          data.forEach((item, index) => {
            item.index = index + 1;
            gids.push(item.gid);
          });
          let filter_gids = {};
          if (this.searchLayer == "Point") {
            filter_gids.point_gids = gids;
          } else if (this.searchLayer == "Line") {
            filter_gids.line_gids = gids;
          } else {
            filter_gids.polygon_gids = gids;
          }
          this.$store.commit("setSearchResultFeatureIDs", filter_gids);
          this.searchResult = data;
        }
        this.isMapSearching = false;
      });
    },
  },
  mounted() {},
};
</script>
 
<style scoped lang="less" >
.attr-searh-wrapper {
  position: absolute;
  width: 500px;
  top: 0px;
  left: 45px;
  z-index: 99;
  background: #fff;
  border: solid 1px #ccc;
  padding: 10px;
  .wrapper {
    border: solid 1px #e7e4e4;
    .title {
      background-color: #f3f8ff;
      height: 35px;
      line-height: 35px;
      padding-left: 10px;
      font-size: 15px;
      .fa-close {
        float: right;
        font-size: large;
        color: #9f9c9c;
        margin-top: 7px;
        margin-right: 10px;
      }
      .fa-close:hover {
        cursor: pointer;
        color: #706e6e;
      }
    }
    .content {
      .filter {
        padding: 10px;
      }
    }
  }
}
</style>

 